import {
  collection,
  getDocs,
  query,
  where,
} from 'firebase/firestore';

import { db } from '../firebase';
import { getCache, setCache } from '../utils/cache';

const TTL = 10 * 60 * 1000;

function monthKey(dateValue = new Date()) {
  const d = dateValue instanceof Date ? dateValue : new Date(dateValue);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
}

function buildLastMonthKeys(count = 12) {
  const keys = [];
  const now = new Date();

  for (let i = count - 1; i >= 0; i -= 1) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    keys.push(monthKey(d));
  }

  return keys;
}

function normalizeRow(key, item = {}) {
  const income = Number(item.incomeTotal || item.income || 0);
  const expenses = Number(item.expensesTotal || item.expenses || 0);
  const payments = Number(item.paymentsTotal || item.payments || 0);
  const invoiced = Number(item.invoicesTotal || item.invoiced || 0);

  return {
    monthKey: key,
    income,
    expenses,
    payments,
    invoiced,
    result: income - expenses - payments,
  };
}

async function fetchStatsByMonthKeys(keys) {
  if (!Array.isArray(keys) || !keys.length) return [];

  const chunks = [];
  for (let i = 0; i < keys.length; i += 10) {
    chunks.push(keys.slice(i, i + 10));
  }

  const allRows = [];

  for (const chunk of chunks) {
    const snap = await getDocs(
      query(collection(db, 'stats'), where('monthKey', 'in', chunk))
    );

    snap.docs.forEach((docSnap) => {
      allRows.push({
        id: docSnap.id,
        ...docSnap.data(),
      });
    });
  }

  return allRows;
}

export async function getDashboardChartStats({ force = false, months = 12 } = {}) {
  const cacheKey = `bauheld:dashboard:charts:${months}`;

  if (!force) {
    const cached = getCache(cacheKey, TTL);
    if (cached) return cached;
  }

  const keys = buildLastMonthKeys(months);
  const statsRows = await fetchStatsByMonthKeys(keys);

  const map = new Map();
  statsRows.forEach((row) => {
    const key = row.monthKey || row.id;
    map.set(key, row);
  });

  const result = keys.map((key) => normalizeRow(key, map.get(key)));

  setCache(cacheKey, result);
  return result;
}
